import { render, staticRenderFns } from "./MenuHistoryIcon.vue?vue&type=template&id=a24a37f6&"
import script from "./MenuHistoryIcon.vue?vue&type=script&lang=ts&"
export * from "./MenuHistoryIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports